import { render, staticRenderFns } from "./ReductionList.vue?vue&type=template&id=518ea554"
import script from "./ReductionList.vue?vue&type=script&lang=ts"
export * from "./ReductionList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports